
































import Vue from 'vue'
import Component from 'vue-class-component'
import { IResidentContact } from '@zunta/configurations'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { User } from '@/classes/User'
import Api from '@/api'
import ResidentContact from '@/views/app/management/components/ResidentContact.vue'
import Card from '@/components/Card.vue'
import ScrollView from '@/components/ScrollView.vue'

@Component({
  components: { ScrollView, Card, ResidentContact }
})
export default class ResidentContactsTab extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  user: User = Api.getUser() as User
  isLoading: boolean = false

  get residentContacts (): IResidentContact[] {
    if (!this.$store.state.resident.residentContacts || !this.$store.state.resident.residentContacts.length) {
      if (this.selectedResident) {
        return [this.selectedResident]
      } else {
        return []
      }
    }
    // const contacts = this.$store.state.resident.residentContacts.filter((contact: IResidentContact) => contact.firstName || contact.lastName)
    const contacts = this.$store.state.resident.residentContacts
    return [this.selectedResident, ...contacts]
  }

  get residentId () {
    return parseInt(this.$route.params.id, 10)
  }

  get selectedResident () {
    return this.$store.state.resident.selectedResident
  }

  async fetchData () {
    try {
      this.isLoading = true
      await this.residentModuleInstance.fetchResidentContacts(this.residentId)
    } finally {
      this.isLoading = false
    }
  }

  mounted () {
    this.fetchData()
  }
}
